module.exports = __webpack_public_path__ + "img/87ea544.jpg";